import styled from "styled-components";
import { blue } from "@ant-design/colors";
import { EditOutlined } from "@ant-design/icons";

import { gray } from "constants/colors";

export const EditIcon = styled(EditOutlined)<{ disabled?: boolean }>`
  color: ${({ disabled }) => (disabled ? gray[4] : blue[4])};
`;
